<template>
    <s-modal
        :open="open"
        @close="$emit('close')"
        :close="true"
        title="Configurer les terrains de votre club"
        :save="zoneSelected!=null"
        @save="saveZone()"
        :cancel="zoneSelected!=null"
        @cancel="cancel()"
    >
        <div v-if="zoneSelected==null">
            <div class="listZone">
            <b>Configurer des zones :</b>
                <div class="tableauZone">
                <div v-for="zoneCurrent in zones" class="ligneZone">
                    {{zoneCurrent.name}} &nbsp;&nbsp; <i>({{zoneCurrent.nb==null ? '0' : (zoneCurrent.nb-zoneCurrent.nbNotDispo)}} terrains)</i>
                    <div style="float:right">
                        <s-button icon="edit" label="" theme="is-primary is-small" @onclick="editZone(zoneCurrent)"/>&nbsp;
                         <s-button :icon="zoneCurrent.default ? 'check-circle' : 'circle'" 
                            label="" 
                            :theme="zoneCurrent.default ? 'is-success is-small' : 'is-dark is-small'" @onclick="setDefault(zoneCurrent)"/>&nbsp;
                    </div>
                </div>
                <div v-if="zones.length==0">
                    <b><i>Aucune zone est défini ...</i></b>
                </div>
                </div>
            </div>
            <b> Ajouter une zone : </b><br/><s-input v-model="nameAdd" theme="is-primary" width="200px" placeholder="Terrains"/>
            &nbsp;<s-button icon="plus" label="" theme="is-success" @onclick="addZone()"/>
            <div class="error" v-if="errorAdd">
                Il y a déjà une zone avec ce nom
            </div>
            <div class="error" v-if="errorNB">
                Vous ne pouvez ajouter que 10 zones
            </div>
             <div class="error" v-if="errorName">
                Le nom de la zone ne doit être vide et doit être en dessous de 7 caractères
            </div>
        </div>
        <div v-if="zoneSelected!=null">
            <div style="margin-bottom: 5px">
                <s-button icon="trash" label="Supprimer" theme="is-danger  is-small" @onclick="deleteZone(zoneSelected)"/>
            </div>
            <div style="margin-bottom: 5px">
                <b>{{zoneSelected.name}}</b>
            </div>
            <div style="margin-bottom: 5px">
                Nombre de terrains :<input  type="number" class="input is-rounded is-primary" v-model="zoneSelected.nb"  placeholder="Saisir le nombre de terrains pour la zone"/>
            </div>
            <div> 
                On commence au numéro : <input type="number" class="input is-rounded is-primary" v-model="numeroBegin"/>
            </div>
            <div style="text-align:center;margin-bottom: 5px">
                <s-button icon="hammer" label="Générer les terrains" theme="is-warning" @onclick="generateTerrain()"
                :disabled="zoneSelected.nb==null || zoneSelected.nb==''"/>
            </div>
            <div class="tableauZone">
                <div v-for="terrain in terrainTab"  >
                    <div style="height:30px" :class="zoneSelected.terrains[terrain.name].disponible ? 'ligneTerrain' : 'ligneTerrainNonDispo'">
                    <div style="float:left">
                        {{terrain.name}}
                    </div>
                    <div style="float:right" class="g_desktopOn">
                        <s-button @onclick="setDispo(terrain.name)"
                            :theme="zoneSelected.terrains[terrain.name].disponible ? 'is-success is-small' : 'is-dark is-small'"
                            :label="zoneSelected.terrains[terrain.name].disponible ? 'disponible' : 'non disponible'"
                            :icon="zoneSelected.terrains[terrain.name].disponible ? 'thumbs-up' : 'thumbs-down'"/>
                    </div>
                     <div style="float:right" class="g_mobileOn">
                        <s-button @onclick="setDispo(terrain.name)"
                            :theme="zoneSelected.terrains[terrain.name].disponible ? 'is-success is-small' : 'is-dark is-small'"
                            label=""
                            :icon="zoneSelected.terrains[terrain.name].disponible ? 'thumbs-up' : 'thumbs-down'"/>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </s-modal>
</template>
<style scoped>
    .ligneTerrain {
        border-bottom: thin border gray;
        margin: 5px;
    }
    .ligneTerrainNonDispo {
          border-bottom: thin border gray;
        margin: 5px;
        background-color: gray;
    }
    .listZone {
        width: 100%;
        margin-bottom: 20px;

    }
    .error {
        color: red;
        font-size: 12px;
    }
    .tableauZone {
        padding-top: 10px;
        padding-left: 20px;
        padding-right: 20px;
        border: thin gray solid;
        height: 200px;
        overflow-y: auto;
    }
    .ligneZone {
        margin-bottom: 10px;
    }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'

export default ({
    props: ["open", "club"],
    data() {
        return {
            zones: [],
            zoneSelected: null,
            nameAdd: "",
            errorAdd: false,
            errorNB: false,
            errorName: false,
            save: false,
            numeroBegin: 1
        }
    },
    computed: {
        terrainTab: {
            get() {
                if (this.zoneSelected!=null) {
                    var tab = [];
                    for (var terrain in this.zoneSelected.terrains) {
                        var elt = this.zoneSelected.terrains[terrain];
                        elt.name = terrain;
                        tab.push(elt);
                    }
                    tab.sort((a,b)=>{
                        return a.numero - b.numero;
                    })
                    return tab;
                }
                else
                    return [];
                
            }
        }
    },
    watch: {
        open(val) {
            if (val) {
                
                this.refresh();
                
                this.numeroBegin = 1;
            }
        }
    },
    methods: {
        setDefault(zone) {
            zone.default = !zone.default;
            
            this.saveZone(zone);

        },
        setDispo(terrainKey) {
            this.zoneSelected.terrains[terrainKey].disponible = !this.zoneSelected.terrains[terrainKey].disponible;
            if (this.zoneSelected.terrains[terrainKey].disponible)
                this.zoneSelected.nbNotDispo--;
            else
                this.zoneSelected.nbNotDispo++;
            
        },
        refresh() {
            this.zoneSelected = null;
            this.zones=[];
            this.errorAdd=false;
            this.errorNB=false;
            this.errorName=false;
            this.nameAdd="";
            firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("terrains").get().then(docs=>{
                        docs.forEach((doc, indiceDoc)=>{
                            this.zones.push(doc.data());
                        })
                    })
        },
        cancel() {
            this.refresh();
        },
        saveZone(zone) {
            var refresh = false;
            if (typeof(zone)=="undefined") {
                zone = this.zoneSelected;
                refresh = true;
            }

            firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("terrains").doc(zone.name).set(zone).then(doc=>{
                        if (refresh)
                            this.refresh();
                    })
        },
        generateTerrain() {
            if (this.zoneSelected.nb=='')
                this.zoneSelected.nb=null;
            else {
                this.zoneSelected.terrains = {};
                var numero = this.numeroBegin;
                for (var i=0;i<this.zoneSelected.nb;i++) {
                    var terrain = {
                        disponible: true,
                        numero: numero
                    }
                    this.zoneSelected.terrains[this.zoneSelected.name+" "+(numero)]= terrain;
                    numero++;
                }
               
                var zone=JSON.parse(JSON.stringify(this.zoneSelected));
                this.zoneSelected=null;
                this.saveZone(zone);
                this.zoneSelected=zone;
            }
            
        },
        editZone(currentZone) {
            this.zoneSelected = currentZone;
            
        },
        deleteZone(zone) {
            firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("terrains").doc(zone.name).delete().then(doc=>{
                        this.refresh();
                    });
            this.errorNB = false;
        },
        addZone() {
            if (this.nameAdd=="" || this.nameAdd.length>7) {
                this.errorName = true;
            }
            else if (this.zones.length>9) {
                this.errorNB = true;
            }
            else if (this.zones.findIndex(elt=>elt.name === this.nameAdd.trim())!=-1)
                this.errorAdd = true;
            else {
                this.errorNB = false;
                this.errorAdd = false;
                this.errorName = false;
                var zone = {
                    name: this.nameAdd.trim(),
                    nb: null,
                    nbNotDispo: 0,
                    terrains: [],
                    default: false
                }
                firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("terrains").doc(zone.name).set(zone).then(doc=>{
                        this.refresh();
                    })
            }
            
        }
    }
})
</script>
